import { Config } from "./config";

const env: Config = {
    API_SERVER_URL: "http://localhost:8000",
    STRIPE_DASHBOARD_URL: "https://dashboard.stripe.com/test",
    WEB_SIGNUP_LINK: "http://localhost:3000/signup",
    FIREBASE_APP: {
        apiKey: "AIzaSyC9CT7xAom_yItBgdG3bw9RA3QKsXBK4qs",
        authDomain: "test-alovendor.firebaseapp.com",
        projectId: "test-alovendor",
        storageBucket: "test-alovendor.firebasestorage.app",
        messagingSenderId: "890851707018",
        appId: "1:890851707018:web:79da774202358456570573",
        measurementId: "G-FKKWX7MWN6",
    },
    SUPPORT_CHAT_LINK: "https://m.me/316878261515934",
};

export default env;
